import { useAppSelector } from 'redux/Hook'

export const getInitialAppDataStatus = () => {
  const user = useAppSelector((state) => state.user)
  const site = useAppSelector((state) => state.site)

  if (user.doneFetching || site.doneFetching) {
    return true
  }

  return false
}
